import React from "react";
import styled from "styled-components";

const Button = styled.button`
    background: #5562c0;
    text-align: center;
    max-width: ${({ width }) => {
        switch (width) {
            case "narrow":
                return "186px";
            case "wide":
            default:
                return "100%";
        }
    }};
    width: 100%;
    height: 61px;
    color: white;
    margin: ${({ align }) => {
        switch (align) {
            case "left":
                return "0 auto 0 0";
            case "center":
                return "0 auto";
            case "right":
            default: 
                return "0 0 0 auto";
        }
    }};
    border: 0;
    border-radius: 0px;
    cursor: pointer;
    display: block;
    font-size: 16px;
    text-transform: uppercase;
`;

export default Button;
